import './App.css';
import './stylesheets/Footer.css';


import 'bootstrap/dist/css/bootstrap.min.css';

import Logo from './componentes/Logo';

import NavegacionPpal from './componentes/plantillas/Navbar';

import Footer from './componentes/plantillas/Footer';

import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import { Box } from "@mui/material";



import Boton from './componentes/Boton';

//import useSound from 'use-sound';
//import mySound from './musica/brasilmusica.mp3';

import { BrowserRouter, Link, Route, Routes} from 'react-router-dom';

import Inicio from "./componentes/paginas/Inicio";

import Presentacion from "./componentes/paginas/Presentacion";
import Posadas from "./componentes/paginas/Posadas";
import Casas from "./componentes/paginas/Casas";
import Apartamentos from "./componentes/paginas/Apartamentos";
import Buceo from "./componentes/paginas/Buceo";
import Kayak from "./componentes/paginas/Kayak";
import Canoa from "./componentes/paginas/Canoa";
import Moto from "./componentes/paginas/Moto";
import AlqAuto from "./componentes/paginas/AlqAuto";
import AlqBuggy from "./componentes/paginas/AlqBuggy";
import Traslados from "./componentes/paginas/Traslados";
import DarkVariantExample from "./componentes/paginas/Opiniones2";
import Playas from "./componentes/paginas/Playas";



import Rio from "./componentes/paginas/Rio";
import Arrial from "./componentes/paginas/Arrial";
import Barco from "./componentes/paginas/Barco";
import Buggy from "./componentes/paginas/Buggy";


function App() {


  const TikTokIcon = ({ color = "#fff", sx = {} }) => {
    return (
      <Box
        component="svg"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 50 50"
        sx={{ width: "1.5em", height: "1.5em", fill: color, ...sx }}
      >
        <path d="M41,4H9C6.243,4,4,6.243,4,9v32c0,2.757,2.243,5,5,5h32c2.757,0,5-2.243,5-5V9C46,6.243,43.757,4,41,4z M37.006,22.323 c-0.227,0.021-0.457,0.035-0.69,0.035c-2.623,0-4.928-1.349-6.269-3.388c0,5.349,0,11.435,0,11.537c0,4.709-3.818,8.527-8.527,8.527 s-8.527-3.818-8.527-8.527s3.818-8.527,8.527-8.527c0.178,0,0.352,0.016,0.527,0.027v4.202c-0.175-0.021-0.347-0.053-0.527-0.053 c-2.404,0-4.352,1.948-4.352,4.352s1.948,4.352,4.352,4.352s4.527-1.894,4.527-4.298c0-0.095,0.042-19.594,0.042-19.594h4.016 c0.378,3.591,3.277,6.425,6.901,6.685V22.323z" />
      </Box>
    );
  };
  

  return (

  <BrowserRouter>

    <div className="App">


            <div className="Cabecera">
                   <Link className="cabeceraLogo" to="/paginas/Inicio" ><Logo /></Link>
                   <div  className="barraNavegador">
                      <NavegacionPpal />
                   </div>   
                   <div className="redesSociales">
                       <a href="https://instagram.com/buziosmaravilloso?igshid=YmMyMTA2M2Y=" target="_blank" rel="nofollow"><InstagramIcon sx={{ color: "#fff" }} /></a>
                       <a href="https://www.facebook.com/buzioshospedaje" target="_blank" rel="nofollow"><FacebookIcon sx={{ color: "#fff" }} /></a> 
                       <a href="https://www.tiktok.com/@buziosmaravilloso" target="_blank" rel="noopener noreferrer nofollow">  <TikTokIcon sx={{ color: "#fff" }} /></a>      
                   </div>
            </div>   
            <div className="ContenidosPaginas">


                      <Routes>
                        <Route path="/" element={<Inicio />} />              
                        <Route path="/buziosmaravilloso" element={<Inicio />} />                      
                        <Route path="/paginas/Inicio" element={<Inicio />} />
                        <Route path="/presentacion" element={<Presentacion />} />

                        <Route path="/alojamientos/posadas" element={<Posadas />} />      
                        <Route path="/alojamientos/casas" element={<Casas />} />          
                        <Route path="/alojamientos/apartamentos" element={<Apartamentos />} />    

                        <Route path="/traslados" element={<Traslados />} />    

                        <Route path="/excursiones/rio" element={<Rio />} />
                        <Route path="/excursiones/arrial" element={<Arrial />} />      
                        <Route path="/excursiones/barco" element={<Barco />} /> 
                        <Route path="/excursiones/moto" element={<Moto />} />                  
                        <Route path="/excursiones/buggy" element={<Buggy />} />                  


                        <Route path="/actividades/buceo" element={<Buceo />} />
                        <Route path="/actividades/kayak" element={<Kayak />} />      
                        <Route path="/actividades/canoa" element={<Canoa />} /> 
                        <Route path="/actividades/moto" element={<Moto />} /> 

                        <Route path="/alquiler/alqauto" element={<AlqAuto />} /> 
                        <Route path="/alquiler/alqbuggy" element={<AlqBuggy />} />  

                        <Route path="/playas" element={<Playas />} />    

                        <Route path="/opiniones" element={<DarkVariantExample />} />    


                      </Routes>  
            </div>   


                    <div >

                        <Footer />


                    </div>
    </div>


  </BrowserRouter>    
         
  );
}

export default App;
